import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../../../assets/images/winnestlogo.png';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <style>{`
        .social-icon {
          text-decoration: none !important;
          color: #ffffff !important;
        }
        
        .social-icon:hover {
          background-color: #16a34a !important;
          color: #ffffff !important;
          text-decoration: none !important;
        }
        
        .social-icon:visited {
          color: #ffffff !important;
        }

        .scroll-top:hover {
          background-color: #16a34a !important;
        }

        .news-item-link:hover .news-item {
          border-color: #22c55e !important;
        }

        .news-item-link:hover {
          transform: translateY(-2px);
          opacity: 0.9;
        }

        .news-item-link:hover .news-title {
          color: #22c55e !important;
        }
      `}</style>

      <footer style={styles.footer}>
        <div style={styles.container}>
          {/* Logo Section */}
          <div style={styles.logoSection}>
            <div style={styles.logoContainer}>
              <div style={styles.logo}>
                <img 
                  src={logoImage} 
                  alt="WinNest Logo" 
                  style={styles.logoImage}
                />
              </div>
              <span style={styles.logoText}>WinNest</span>
            </div>
          </div>

          {/* Main Footer Content */}
          <div style={styles.footerContent}>
            {/* Working Hours and Contact Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Working hours</h3>
              <p style={styles.sectionSubtitle}>
                Reach out to us anytime and reshape your financial future
              </p>

              <div style={styles.contactInfo}>
                <div style={styles.contactRow}>
                  <span style={styles.greenIcon}>✓</span>
                  <span style={styles.contactText}>vcare@winnest.in</span>
                </div>
                <div style={styles.contactRow}>
                  <span style={styles.greenIcon}>📞</span>
                  <span style={styles.contactText}>+91 90360 24568 +91 90360 25568</span>
                </div>
                <div style={styles.workingHours}>
                  <span style={styles.clockIcon}>🕘</span>
                  <div>
                    <div style={styles.contactText}>Mon - Sat 09:00 - 18:00</div>
                    <div style={styles.contactText}>Sunday closed</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Latest News Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Latest News</h3>
              <div style={styles.newsItems}>
                <Link to="/blogs" style={styles.newsItemLink} className="news-item-link">
                  <div style={styles.newsItem} className="news-item">
                    <div style={styles.newsDate}>August 01, 2025</div>
                    <div style={styles.newsTitle} className="news-title">Benefits of Investing in Mutual Funds</div>
                  </div>
                </Link>
                <Link to="/blogs" style={styles.newsItemLink} className="news-item-link">
                  <div style={styles.newsItem} className="news-item">
                    <div style={styles.newsDate}>August 04, 2025</div>
                    <div style={styles.newsTitle} className="news-title">Difference Between Equity Funds and Debt Funds</div>
                  </div>
                </Link>
                <Link to="/blogs" style={styles.newsItemLink} className="news-item-link">
                  <div style={styles.newsItem} className="news-item">
                    <div style={styles.newsDate}>August 13, 2025</div>
                    <div style={styles.newsTitle} className="news-title">Three things you should know about Financial Planning</div>
                  </div>
                </Link>
              </div>
            </div>

            {/* Coming Soon Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Coming Soon</h3>
              <div style={styles.appButtons}>
                <div style={styles.appButton}>
                  <div style={styles.playIcon}>▶</div>
                  <div style={styles.appButtonText}>
                    <div style={styles.getItOn}>GET IT ON</div>
                    <div style={styles.storeName}>Google Play</div>
                  </div>
                </div>
                <div style={styles.appButton}>
                  <div style={styles.appleIcon}>🍎</div>
                  <div style={styles.appButtonText}>
                    <div style={styles.getItOn}>Available on the</div>
                    <div style={styles.storeName}>App Store</div>
                  </div>
                </div>
              </div>

              <div style={styles.supportSection}>
                <div style={styles.supportTitle}>SUPPORT CENTER 24/7</div>
                <div style={styles.supportNumbers}>
                  <div style={styles.supportNumber}>+91 90360 24568</div>
                  <div style={styles.supportNumber}>+91 90360 25568</div>
                </div>
              </div>
            </div>
          </div>

          {/* Risk Factors Disclaimer */}
          <div style={styles.disclaimerSection}>
            <p style={styles.disclaimerText}>
              <span style={styles.boldText}>Risk Factors – </span>
              Investments in Mutual Funds are subject to Market Risks. Read all the scheme related documents carefully before investing. Mutual Fund Schemes do not assure or guarantee any returns. Past performances of any Mutual Fund Scheme may or may not be sustained in future. There is no guarantee that the investment objective of any suggested scheme shall be achieved. All existing and prospective investors are advised to check and evaluate the Exit loads and other cost structure (TER) applicable at the time of making the investment before finalizing on any investment decision for Mutual Funds schemes. We deal in Regular Plans only for Mutual Fund Schemes and earn a Trailing Commission on client investments. Disclosure For Commission earnings is made to clients at the time of investments. Option of Direct Plan for every Mutual Fund Scheme is available to investors offering advantage of lower expense ratio. We are not entitled to earn any commission on Direct plans. Hence we do not deal in Direct Plans.
            </p>

            <div style={styles.registrationInfo}>
              <p style={styles.registrationText}>
                <span style={styles.boldText}>AMFI Registered Mutual Fund Distributor – ARN-81431</span> | Date of initial registration – 01 June 2010 | Current validity of ARN – 10 October 2028
              </p>
              <p style={styles.registrationText}>
                <span style={styles.boldText}>Grievance Redressal:</span> For any complaints or grievances, please contact our Grievance Officer: Mr. Sunil Kumar | Email: grievance@winnest.in | Phone: +91 90360 24568 | Escalation: AMFI Investor Grievance Portal at portal.amfiindia.com
              </p>
              <p style={styles.registrationText}>
                <span style={styles.boldText}>Corporate Details:</span> WinNest Financial Services Private Limited | CIN: U74999KA2010PTC054321 | GST: 29AAACC1234F1Z5 | Registered Office: #123, 4th Cross, Jayanagar, Bengaluru - 560041
              </p>
            </div>
          </div>

          {/* Bottom Section */}
          <div style={styles.bottomSection}>
            <div style={styles.copyrightSection}>
              <div style={styles.copyright}>
                Copyright 2025. WinNest
              </div>
              <div style={styles.footerLinks}>
                <Link to="/important-links" style={styles.footerLink}>Important Links</Link>
                <span style={styles.linkSeparator}>|</span>
                <Link to="/disclaimer" style={styles.footerLink}>Disclaimer</Link>
                <span style={styles.linkSeparator}>|</span>
                <Link to="/privacy-policy" style={styles.footerLink}>Privacy Policy</Link>
                <span style={styles.linkSeparator}>|</span>
                <Link to="/terms-conditions" style={styles.footerLink}>Terms & Conditions</Link>
                <span style={styles.linkSeparator}>|</span>
                <Link to="/cookie-policy" style={styles.footerLink}>Cookie Policy</Link>
                <span style={styles.linkSeparator}>|</span>

                {/* External links using anchor tags */}
                <a
                  href="https://www.amfiindia.com/investor-corner/knowledge-center/scheme-information-documents.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.footerLink}
                >
                  SID/SAI/KIM
                </a>
                <span style={styles.linkSeparator}>|</span>

                <a
                  href="https://resources.investwellonline.com/due-diligence/AMFI_Code-of-Conduct.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.footerLink}
                >
                  Code of Conduct
                </a>
                <span style={styles.linkSeparator}>|</span>

                <a
                  href="https://www.amfiindia.com/distributor/amfi-circulars"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.footerLink}
                >
                  AMFI Circulars
                </a>
                <span style={styles.linkSeparator}>|</span>

                <a
                  href="https://www.amfiindia.com/investor-corner/knowledge-center/risks-in-mutual-funds.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.footerLink}
                >
                  AMFI Risk Factors
                </a>
              </div>
            </div>
            <div style={styles.socialAndScroll}>
              <div style={styles.socialIcons}>
                <a
                  href="https://www.facebook.com/winnest.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.socialIcon}
                  className="social-icon"
                >
                  f
                </a>
                <a
                  href="https://www.instagram.com/winnest.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.socialIcon}
                  className="social-icon"
                >
                    📷
                </a>
                <a
                  href="https://www.linkedin.com/company/winnest-financial"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.socialIcon}
                  className="social-icon"
                >
                  in
                </a>
                <a
                  href="https://x.com/WinNest_in"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.socialIcon}
                  className="social-icon"
                >
                  𝕏
                </a>
              </div>
              <div 
                style={styles.scrollTop} 
                className="scroll-top"
                onClick={scrollToTop}
              >
                <div style={styles.scrollIcon}>↑</div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

const styles = {
  footer: {
    backgroundColor: '#2a2a2a',
    color: '#ffffff',
    fontFamily: 'Arial, sans-serif',
    padding: '60px 0 0 0',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 20px',
  },
  logoSection: {
    marginBottom: '40px',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logo: {
    width: '40px',
    height: '40px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
  },
  logoImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  logoText: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#ffffff',
  },
  footerContent: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '40px',
    marginBottom: '40px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '16px',
    color: '#ffffff',
  },
  sectionSubtitle: {
    fontSize: '14px',
    color: '#b0b0b0',
    marginBottom: '20px',
    lineHeight: '1.5',
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  contactRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  workingHours: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  greenIcon: {
    color: '#22c55e',
    fontSize: '16px',
    minWidth: '20px',
  },
  clockIcon: {
    fontSize: '16px',
    minWidth: '20px',
  },
  contactText: {
    fontSize: '14px',
    color: '#b0b0b0',
  },
  supportSection: {
    marginTop: '20px',
  },
  supportTitle: {
    fontSize: '12px',
    color: '#b0b0b0',
    marginBottom: '8px',
  },
  supportNumbers: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  supportNumber: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#22c55e',
  },
  appButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  appButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: '#3a3a3a',
    border: '1px solid #4a4a4a',
    borderRadius: '8px',
    padding: '12px 16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  playIcon: {
    fontSize: '20px',
    color: '#22c55e',
  },
  appleIcon: {
    fontSize: '20px',
  },
  appButtonText: {
    display: 'flex',
    flexDirection: 'column',
  },
  getItOn: {
    fontSize: '10px',
    color: '#b0b0b0',
    textTransform: 'uppercase',
  },
  storeName: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#ffffff',
  },
  newsItems: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  newsItemLink: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    transition: 'transform 0.2s ease, opacity 0.2s ease',
  },
  newsItem: {
    borderBottom: '1px solid #3a3a3a',
    paddingBottom: '16px',
    cursor: 'pointer',
    transition: 'border-color 0.3s ease',
  },
  newsDate: {
    fontSize: '12px',
    color: '#22c55e',
    fontWeight: 'bold',
    marginBottom: '8px',
  },
  newsTitle: {
    fontSize: '14px',
    color: '#b0b0b0',
    lineHeight: '1.4',
  },
  disclaimerSection: {
    marginBottom: '30px',
  },
  disclaimerText: {
    fontSize: '12px',
    color: '#b0b0b0',
    lineHeight: '1.6',
    marginBottom: '15px',
    textAlign: 'justify',
  },
  registrationInfo: {
    textAlign: 'center',
    marginBottom: '10px',
  },
  registrationText: {
    fontSize: '12px',
    color: '#b0b0b0',
    lineHeight: '1.4',
  },
  boldText: {
    fontWeight: 'bold',
    color: '#ffffff',
  },
  bottomSection: {
    borderTop: '1px solid #3a3a3a',
    paddingTop: '20px',
    paddingBottom: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px',
  },
  copyrightSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  copyright: {
    fontSize: '12px',
    color: '#b0b0b0',
  },
  footerLinks: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
  },
  footerLink: {
    fontSize: '12px',
    color: '#d4a574',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
  },
  linkSeparator: {
    fontSize: '12px',
    color: '#b0b0b0',
  },
  socialAndScroll: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  socialIcons: {
    display: 'flex',
    gap: '8px',
  },
  socialIcon: {
    width: '36px',
    height: '36px',
    backgroundColor: '#22c55e',
    color: '#ffffff',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    textDecoration: 'none',
  },
  scrollTop: {
    width: '40px',
    height: '40px',
    backgroundColor: '#22c55e',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  scrollIcon: {
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: 'bold',
  },
};

export default Footer;